<template>
	<!-- 帳戶設定 -->
	<div class="deal_index_box">
		<!-- 内容 -->
		<div class="deal_title">
			<div>帳戶設定<span>》</span>修改管理員資訊</div>
			<div class="deal_hr">
				<div class="cut_off"></div>
			</div>
		</div>
		<!-- 修改管理員資訊 -->
		<div class="deal_content_box">
			<div class="deal_content_title">修改最高權限管理員資訊</div>
			<el-form label-width="160px" class="deal_content div_hight_end" v-if="paymentsd">
				<el-form-item class="list_high_end" label="商家編號：">
					<el-col :span="5" :xs="8">
						<span>{{uid}}</span>
					</el-col>
				</el-form-item>
				<el-form-item class="list_high_end" label="最高權限管理員姓名：">
					<el-col :span="5" :xs="8">
						<span>{{principal}}</span>
					</el-col>
				</el-form-item>
				<el-form-item class="list_high_end" label="綁定手機：">
					<span>{{telephone}}</span>
					<span class="div_bntoon">點擊進入修改綁定手機號及最高權限管理員姓名入口</span>
				</el-form-item>
				<el-row class="paind_bottm_end flex_display" v-if="telephoneTF">
					<div class="right_col">
						<span class="list_span">*</span>簡訊驗證碼：
					</div>
					<el-col :xs="8" :sm="10" :md="8" :lg="4" class="input_high">
						<el-input v-model="code" maxlength="6"></el-input>
					</el-col>
					<el-col :xs="8" :sm="10" :md="3" :lg="2" class="button_cetent">
						<el-button type="danger" class="bottom_two" @click="axiosVerification()">{{buttonText}}</el-button>
					</el-col>
					<el-col :span="6">
						<div class="right_col_left">沒有收到驗證碼？</div>
					</el-col>
				</el-row>
				<el-form-item class="paind_bottm_end " prop="secrtTf" label="google驗證碼：" v-if="secretTF">
					<el-col :xs="8" :sm="10" :md="8" :lg="4" class="input_high">
						<el-input v-model="secret" maxlength="6"></el-input>
					</el-col>
				</el-form-item>
				<el-form-item class="paind_bottm" prop="trader_password" label="您的交易密碼：" v-if="traderPassTF">
					<el-col :span="6" :xs="10" class="input_high">
						<el-input v-model="trader_password" maxlength="6" type="password"></el-input>
						<div class="p_cetent">預留資訊：<span>{{reserved}}</span></div>
					</el-col>
					<el-col :span="6">
						<div class="right_col_left" @click="gologinadl()">忘記交易密碼</div>
					</el-col>
				</el-form-item>
				<el-form-item class="paind_bottm_end " label="電子信箱：">
					<el-col :xs="8" :sm="10" :md="8" :lg="4" class="input_high pasd_sever">
						<el-input v-model="mailbox"></el-input>
					</el-col>
				</el-form-item>
				<el-form-item class="paind_bottm_end painde_top">
					<el-col :span="3">
						<div class="lstl_bock"></div>
					</el-col>
					<el-col :span="15" class="button_stend">
						<el-button type="danger" plain class="bottom_onew" @click="goAccount()">返回</el-button>
						<el-button type="danger" class="bottom_two" @click="gobuilder()">送出</el-button>
					</el-col>
				</el-form-item>
			</el-form>
			<div class="deal_content div_hight_dedt" v-if="paymentslue">
				<el-row>
					<el-col :span="12" :xs="12" class="list_tile_sed icon_phigt">
						<i class="el-icon-warning colro-red"></i><span>更新管理員資訊內容正在等待審核通過，等待過程中不影響正常交易</span>
					</el-col>
				</el-row>

			</div>
		</div>
	</div>



</template>

<script>
	import axios from 'axios';
	export default {
		name: 'LoginDealIndex',
		data() {
			return {
				message:'',
				timeto:60,
				countTime:60,
				mailbox: '',
				code: '',
				secret: '',
				trader_password: '',
				traderPassTF: '',
				telephoneTF: '',
				secretTF: '',
				reserved: '',
				uid: '',
				telephone: '',
				principal: '',
				paymentslue: false,
				paymentsd:true,
				buttonText: '點擊發送驗證碼',
				remind:"",
				// return
			}
		},
		methods: {
			// 返回
			goAccount(){
				this.$router.push('/login/account');
			},
			// 重设交易密码
			gologinadl() {
				this.$router.push('/login/account/loginadl')
			},
			// 点击提交验证
			gobuilder() {
				if (this.$store.state.secretTF != '-1') {
					this.codeVerification(this.secret, 'google驗證碼')
				} else if (this.$store.state.traderPassTF != '-1') {
					this.codeVerification(this.trader_password, '交易密碼')
				} else {
					this.codeVerification(this.code, '簡訊驗證碼')
					if(this.message!=this.code){
						this.$message({
							showClose: true,
							message: '簡訊驗證碼錯誤',
							type: 'error',
							duration: 1000
						});
						return
					}
				}
				this.mailVerification(this.mailbox)
				this.emailaxiosemail()

			},

			// 读取全局变量判断显示输入框
			listaccount() {
				this.reserved = this.$store.state.reserved;
				this.uid = this.$store.state.uid;
				this.principal = this.$store.state.principal;
				if (this.$store.state.telephone != '-1' && this.$store.state.telephone != 'null') {
					this.telephone = this.$store.state.telephone
				} else {
					this.telephone = '未綁定'
				}
				if (this.$store.state.secretTF != '-1') {
					this.traderPassTF = false;
					this.telephoneTF = false;
					this.secretTF = true;
				} else {
					if (this.$store.state.traderPassTF != '-1') {
						this.traderPassTF = true;
						this.telephoneTF = false;
						this.secretTF = false;
					} else {
						this.telephoneTF = true;
						this.secretTF = false;
						this.traderPassTF = false;
					}

				}

			},
			// 点击发送短信验证
			axiosVerification() {
				console.log(11)
				axios.get(this.$store.state.axiosPhone, {
					params: {
						telnum: this.$store.state.telephone
					}
				}).then((res) => {
					this.status = res.data.status;
					this.message = res.data.message;
					console.log(res.data);
					if (this.status) {
						this.message = res.data.message;
						this.disabledTF = true;
						this.ShowSucc = true;
						this.ShowError = false;
						this.verify = "已發送驗證碼";
						// 倒計時
						this.buttonText = this.timeto + "秒後，可再次發送";
						let count = setInterval(() => {
							this.timeto -= 1;
							this.buttonText = this.timeto + "秒後，可再次發送";
							if (this.timeto < 0) {
								clearInterval(count);
								this.buttonText = '發送驗證碼';
								this.timeto = this.countTime;
								this.disabledTF = false;
								return
							}
						}, 1000);
					} else {
						this.ShowSucc = false;
						this.ShowError = true;
						this.remind = "手機已存在，歡迎重新登入";
					}
				})
			},
			// FUN-輸入驗證碼-01
			clickVerification() {
				// 发送ajax；
				this.axiosVerification();
			},
			// 限制交易密码
			verification(str) {
				var pattern = /\D/;
				if (!pattern.test(str)) {
					return false;
				} else {
					return true;
				}
			},
			// 限制邮箱
			mailverification(str) {
				var pattern = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
				if (pattern.test(str)) {
					return false;
				} else {
					return true;
				}

			},

			// 分裝是否為空驗證
			codeVerification(code, listmi) {
				if (code == '') {
					this.$message({
						showClose: true,
						message: listmi + '不能為空',
						type: 'error',
						duration: 1000
					});
					return
				} else if (this.verification(code)) {
					this.$message({
						showClose: true,
						message: listmi + '為純數字',
						type: 'error',
						duration: 1000
					});
					return
				}
			},
			// 验证邮箱
			mailVerification(mail) {
				console.log(4)
				if (mail == '') {
					this.$message({
						showClose: true,
						message: '邮箱不能为空',
						type: 'error',
						duration: 1000
					});
					return
				} else if (this.mailverification(mail)) {
					console.log(8)
					this.$message({
						showClose: true,
						message: '邮箱格式错误',
						type: 'error',
						duration: 1000
					});
					return
				}
			},
			// 修改邮箱请求
			emailaxiosemail() {
				axios.get(this.$store.state.axiosemail, {
					params: {
						uid :this.$store.state.uid,
						action:1,
						trader_password: this.trader_password,
						secret: this.secret,
						mailbox: this.mailbox,
					}
				}).then((res) => {
					console.log(res)
					this.status = res.data.status;
					this.message = res.data.message;
					if (!this.status){			
						if (this.status == -1){
							this.$message({
								showClose: true,
								message: '交易密碼有誤，請重新輸入',
								type: 'error',
								duration: 1000
							});
						}else {
							this.$message({
								showClose: true,
								message: this.message,
								type: 'error',
								duration: 1000
							});
						}
					}else{
						this.paymentslue = true;
						this.paymentsd=false;
					}
				})

			}
		},
		mounted() {
			this.listaccount()

		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.p_cetent span {
		color: #13AE22;
	}

	/* 表頭 */
	.deal_index_box {
		margin: 20px;
		font-size: 15px;
		color: black;
	}

	.deal_title {
		display: flex;
		justify-content: flex-start;
		padding-bottom: 10px;
	}

	.deal_title span {
		margin-left: 15px;
		margin-right: 8px;
	}

	.deal_title .deal_hr {
		flex: 1;
		margin-left: 18px;
	}

	.deal_title .deal_hr .cut_off {
		height: 3px;
		background: black;
		margin-top: 8px;
	}

	/* 内容 */
	.datetime_box>span {
		margin: 10px;
	}

	.deal_content_box {
		font-size: 13px;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.deal_content_title {
		height: 42px;
		background: #666666;
		line-height: 42px;
		color: white;
		padding-left: 14px;
	}

	.deal_content {
		box-sizing: border-box;
		/* height: 53.6vw; */
		/* min-height: 100px; */
		border: 1px solid #666666;
		background: #ffffff;
		padding: 0 20px;
		padding-top: 26px;
	}

	.deal_content_span {
		margin-left: 23px;
		font-size: 11px;
		color: #e73262;
	}

	.deal_content_tab_first {
		width: 960px;
		margin: 0 auto;
	}

	.deal_content_tab_first>div {
		margin: 14px 0;
	}

	.money_box span {
		margin: 0 10px;
	}

	.money_input {
		width: 140px;
		/* margin-left: 4px; */
	}

	.money_input01 {
		margin-left: 4px;
	}

	.inquire_button {
		padding: 10px 0;
	}



	/* 方塊顯示 */
	.list_high {
		color: #666666;
		display: flex;
		height: 36px;
		line-height: 36px;
		font-size: 13px;
	}

	.div_hight {
		padding-top: 10px;
	}

	.btn_lits {
		padding-top: 0px;
		padding-bottom: 0px;
		padding-left: 7px;
		padding-right: 7px;
		height: 16px;
		border-top-width: 1px;
		margin-top: 9px;
		margin-left: 10px;
		font-size: 11px;
		background: #e73262;
	}

	.div_hight_end {
		padding: 25px 40px;

	}

	.list_high_end {
		line-height: 35px;
	}

	.div_hight_one {
		padding-top: 20px;
		padding-bottom: 30px;

	}

	.list_high_one {

		line-height: 35px;
	}

	.deal_content_title span {
		display: block;
		height: 35px;
		width: 30px;
		float: right;
		padding-left: 10px;
		padding-top: 5px;
		background: url("../../../../assets/img/user/service_list.png") center no-repeat;
	}

	.lstl_bock {
		height: 1px;
	}

	.div_left {
		padding-left: 60px;
	}

	/* 經營者資料 */
	.lest_hist {
		border-left: 10px solid #e73262;
		font-size: 15px;
	}

	.list_new {
		padding-left: 30px;
	}

	.list_two {
		padding-left: 20px;
	}

	.div_bottom div {
		margin-bottom: 25px;
		color: #777777;
	}

	.img_title img {
		width: 260px;

	}

	.dist_hites_tow {
		margin: 30px;
	}

	.input_high .el-input .el-input__inner {
		height: 27px;
		border: 1px solid #cccccc;
	}

	.input_high {
		padding-left: 10px;
	}

	.check_right label {
		margin-right: 5px;
	}

	.list_tile_sed {
		background-color: #fff4cc;
		line-height: 40px;
		margin: 10px 100px 25px 10px;

	}

	.colro-red {
		color: #ff4a05;
		font-size: 20px;
	}

	.list_span {
		color: #e73262;
	}

	.right_col {
		padding-top: 7px;
		float: right;
	}

	.right_col_left {
		color: #4d80e7;
		padding-top: 7px;
		padding-left: 15px;
	}

	.list_span_end {
		color: #e73262;
		padding-top: 7px;
		padding-left: 15px;
	}

	.div_bntoon {
		color: #e73262;
		border-bottom: 1px solid #e73262;
		margin-left: 20px;
	}

	.button_cetent {
		padding-top: 2px;
		padding-bottom: 25px;
		padding-left: 10px;
	}

	.button_cetent button {
		background-color: #ff771a;
		border: #ff771a;
		height: 20px;
		padding-bottom: 5px;
		padding-top: 2px;
		padding-left: 3px;
		padding-right: 3px;
		width: 120px;
		font-size: 11px;
	}

	.button_stend {
		margin-top: 10px;
		padding-bottom: 25px;
	}

	.button_stend button {

		height: 22px;
		padding-bottom: 5px;
		padding-top: 2px;
		padding-left: 8px;
		padding-right: 10px;
		width: 45px;
		font-weight: 700;
	}

	.painde_top {
		padding: 40px 0px 40px 0px;
	}

	.bottom_onew {
		color: #e73262;
		border-color: #e73262;
	}

	.bottom_two {
		background: #e73262;

	}

	.icon_phigt {
		padding: 5px;
		margin-bottom: 100px;
	}

	.flex_display {
		display: flex;
		color: #606266;
	}

	.flex_div {
		padding-left: 12px;
	}
</style>
